export enum CanBasketBeChangedChecks {
  statusCheck = 'statusCheck',
  isFrozenReviewCheck = 'isFrozenReviewCheck',
  isFrozenReviewByRuleCheck = 'isFrozenReviewByRuleCheck',
  hasDeletedAddressCheck = 'hasDeletedAddressCheck',
  isReadOnlyCheck = 'isReadOnlyCheck',
}

export type CanBasketBeChanged = {
  [key in CanBasketBeChangedChecks]: boolean;
};
